module.exports = __webpack_public_path__ + "static/media/tg_green_tick.0097bca5.webp";